import { seoLinks, ogImage } from "@/lib/seo";
import { createFileRoute } from "@tanstack/react-router";

import { FoodMenu } from "@/components/site/FoodMenu";
import { CtaBand, PageHero, Prose } from "@/components/site/Page";

const TITLE = "Menú escolar y comedor | Swedish International School";
const DESCRIPTION =
  "Cómo funciona el comedor en nuestro colegio entre Estepona y Marbella: almuerzo caliente cada día lectivo, dietas especiales y el menú publicado al estar listo.";

export const Route = createFileRoute("/es/menu-escolar")({
  head: () => ({
    meta: [
      { title: TITLE },
      { name: "description", content: DESCRIPTION },
      { property: "og:title", content: TITLE },
      { property: "og:description", content: DESCRIPTION },
      { property: "og:type", content: "article" },
      { name: "twitter:card", content: "summary_large_image" },
      { property: "og:locale", content: "es_ES" },
      ...ogImage(),
    ],
    links: seoLinks("/es/menu-escolar"),
  }),
  component: MenuEscolar,
});

function MenuEscolar() {
  return (
    <>
      <PageHero
        eyebrow="Menú escolar"
        title="Menú y comedor"
        intro="El almuerzo se sirve en el colegio los días lectivos ordinarios. El menú se publica en cuanto está listo y puede haber cambios puntuales."
      />

      <FoodMenu locale="es" />

      <Prose>
        <h2>Alérgenos y dietas especiales</h2>
        <p>
          Adaptamos la comida a alergias e intolerancias documentadas y ofrecemos alternativa
          vegetariana. Indícanos las necesidades del alumno en la solicitud o escríbenos y lo
          resolvemos antes del primer día.
        </p>
        <h2>Durante las vacaciones</h2>
        <p>
          No se publica menú durante las vacaciones escolares. Las fechas están en{" "}
          <a className="text-primary link-quiet" href="/es/calendario-escolar">el calendario escolar</a>.
        </p>
      </Prose>

      <CtaBand locale="es" />
    </>
  );
}
